const PHONE_CANDIDATE_PATTERN = /[+(\d][\d+().\- \t]*\d/g;

function protectPhoneNumberSeparators(value) {
    if (typeof value !== 'string' || !value) return value;

    return value.replace(PHONE_CANDIDATE_PATTERN, (candidate) => {
        const digitCount = (candidate.match(/\d/g) || []).length;
        if (digitCount < 7) return candidate;

        return candidate.replace(/[ \t]/g, '\u00a0').replace(/-/g, '\u2011');
    });
}

function protectTextNodes(node, skip = false) {
    if (!node || typeof node !== 'object') return;

    const tagName =
        node.type === 'element' && typeof node.tagName === 'string'
            ? node.tagName.toLowerCase()
            : '';
    const shouldSkip =
        skip ||
        ['code', 'pre', 'script', 'style', 'textarea'].includes(tagName);

    if (node.type === 'text' && !shouldSkip) {
        node.value = protectPhoneNumberSeparators(node.value);
        return;
    }

    node.children?.forEach((child) => protectTextNodes(child, shouldSkip));
}

function rehypeProtectPhoneNumbers() {
    return (tree) => protectTextNodes(tree);
}

module.exports = { protectPhoneNumberSeparators, rehypeProtectPhoneNumbers };
